/* ==========================================================================
   assets/about-core.v2.js（完全版 / SPでもparallax動作版）
   - 変更点：
     1) initFloat() の「win.innerWidth < 900 でreturn」を撤去
     2) SPは parallax depth を弱める（0.45倍）
     3) prefers-reduced-motion: reduce は停止
   ========================================================================== */
(function () {
  'use strict';

  // ===== Multi-init guard (Theme Editor safe) =====
  if (window.__SSS_ABOUT_CORE_V2__ === true) return;
  window.__SSS_ABOUT_CORE_V2__ = true;

  var doc = document;
  var win = window;

  function ready(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function rafThrottle(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        fn();
      });
    };
  }

  // ==========================
  // 1) Overlay (darken) + hero color switch + fade-in
  // ==========================
  function initOverlayAndFade() {
    var overlayEl = doc.querySelector('[data-about-overlay]');
    var depthEl   = doc.querySelector('[data-about-offset]');
    var heroEl    = doc.querySelector('.sss-about__hero');
    if (!overlayEl || !depthEl) return;

    var fades = Array.prototype.slice.call(doc.querySelectorAll('.u-fade'));

    function getDepthPx() {
      var h = depthEl.offsetHeight || 0;
      if (h > 0) return h;

      var dh = Math.max(
        doc.body.scrollHeight || 0,
        doc.documentElement.scrollHeight || 0
      );
      return Math.max(1, dh * 0.35);
    }

    function computeOverlay() {
      var depth = getDepthPx();
      var y = win.scrollY || win.pageYOffset || 0;

      var t = clamp(y / depth, 0, 0.62);
      overlayEl.style.opacity = String(t);

      if (heroEl) heroEl.classList.toggle('is-white', t > 0.30);
    }

    function computeFade() {
      var y = win.scrollY || win.pageYOffset || 0;
      var vh = win.innerHeight || 0;

      for (var i = 0; i < fades.length; i++) {
        var el = fades[i];
        if (el.classList.contains('u-fade--in')) continue;

        var rect = el.getBoundingClientRect();
        var top = rect.top + y;
        if (y > top - vh + 140) el.classList.add('u-fade--in');
      }
    }

    var onTick = rafThrottle(function () {
      computeOverlay();
      computeFade();
    });

    ['scroll', 'resize', 'load', 'pageshow'].forEach(function (evt) {
      win.addEventListener(evt, onTick, { passive: true });
    });

    onTick();
  }

  // ==========================
  // 2) Tabs (Episode)
  // ==========================
  function initTabs() {
    var tabEls = Array.prototype.slice.call(doc.querySelectorAll('.sss-tabs [role="tab"]'));
    if (!tabEls.length) return;

    function setActive(idx, pushHash) {
      if (typeof pushHash === 'undefined') pushHash = true;

      for (var i = 0; i < tabEls.length; i++) {
        var isOn = (i === idx);
        var t = tabEls[i];
        t.classList.toggle('is-active', isOn);
        t.setAttribute('aria-selected', String(isOn));

        var panelId = t.getAttribute('aria-controls');
        var panel = panelId ? doc.getElementById(panelId) : null;
        if (panel) {
          panel.classList.toggle('is-active', isOn);
          panel.hidden = !isOn;
        }
      }

      if (pushHash && win.history && win.history.replaceState) {
        win.history.replaceState(null, '', '#ep' + (idx + 1));
      }
    }

    tabEls.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(i, true); });

      t.addEventListener('keydown', function (e) {
        var k = e.key || e.keyCode;
        if (k === 'ArrowRight' || k === 39 || k === 'ArrowLeft' || k === 37) {
          e.preventDefault();
          var dir = (k === 'ArrowRight' || k === 39) ? 1 : -1;
          var next = (i + dir + tabEls.length) % tabEls.length;
          tabEls[next].focus();
          setActive(next, false);
        }
      });
    });

    var m = (location.hash || '').match(/^#ep([1-9]\d*)$/);
    if (m) {
      var idx = clamp(parseInt(m[1], 10) - 1, 0, tabEls.length - 1);
      setActive(idx, false);
    } else {
      tabEls.forEach(function (t) {
        var panelId = t.getAttribute('aria-controls');
        var panel = panelId ? doc.getElementById(panelId) : null;
        if (panel) panel.hidden = !panel.classList.contains('is-active');
      });
    }
  }

  // ==========================
  // 3) "Our Approach" rise-in view
  // ==========================
  function initApproachInview() {
    var root = doc.querySelector('.js-approach');
    if (!root) return;

    if (!('IntersectionObserver' in win)) {
      root.classList.add('is-inview');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          root.classList.add('is-inview');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.15 });

    io.observe(root);
  }

  // ==========================
  // 4) Marquee (endless horizontal)
  // ==========================
  function initMarquee() {
    var slider = doc.querySelector('.js-about-marquee');
    if (!slider) return;

    function clearClones() {
      var kids = Array.prototype.slice.call(slider.children);
      kids.forEach(function (el) {
        if (el && el.dataset && el.dataset.clone === '1') slider.removeChild(el);
      });
      slider.classList.remove('is-css-marquee');
      slider.style.removeProperty('--marquee-x');
      slider.style.removeProperty('--marquee-dur');
      slider.style.removeProperty('transform');
    }

    function children() {
      return Array.prototype.slice.call(slider.children);
    }

    function measureWidth(items) {
      var w = 0;
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var rect = el.getBoundingClientRect();
        var cs = win.getComputedStyle(el);
        var ml = parseFloat(cs.marginLeft) || 0;
        var mr = parseFloat(cs.marginRight) || 0;
        w += rect.width + ml + mr;
      }
      return w;
    }

    function ensureLoadedThen(startFn) {
      setTimeout(startFn, 40);
      setTimeout(startFn, 240);
      setTimeout(startFn, 700);
    }

    function startCSS() {
      clearClones();

      var base = children();
      if (!base.length) return;

      for (var i = 0; i < base.length; i++) {
        var clone = base[i].cloneNode(true);
        clone.dataset.clone = '1';
        slider.appendChild(clone);
      }

      var all = children();
      var half = all.slice(0, all.length / 2);
      var w = measureWidth(half);

      var pxPerSec = 45;
      var dur = Math.max(18, w / pxPerSec);

      slider.style.setProperty('--marquee-x', (-w) + 'px');
      slider.style.setProperty('--marquee-dur', dur.toFixed(2) + 's');
      slider.classList.add('is-css-marquee');
    }

    function startGSAP() {
      if (!win.gsap) return false;

      clearClones();

      var base = children();
      if (!base.length) return true;

      var w = measureWidth(base);

      for (var i = 0; i < base.length; i++) {
        var clone = base[i].cloneNode(true);
        clone.dataset.clone = '1';
        slider.appendChild(clone);
      }

      var speed = 70;
      var dur = Math.max(18, w / speed);

      win.gsap.killTweensOf(slider);
      win.gsap.set(slider, { x: 0 });
      win.gsap.to(slider, {
        x: -w,
        duration: dur,
        ease: 'none',
        repeat: -1,
        onRepeat: function () { win.gsap.set(slider, { x: 0 }); }
      });

      return true;
    }

    function build() {
      if (startGSAP()) return;
      startCSS();
    }

    ensureLoadedThen(build);

    var rt;
    win.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        build();
      }, 250);
    });
  }

  // ==========================
  // 5) Float/Parallax (no GSAP)  ※SPでも動く版
  // ==========================
  function initFloat() {
    // ユーザーが「動き減らす」設定なら止める
    if (win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var wraps = Array.prototype.slice.call(doc.querySelectorAll('.js-parallax'));
    if (!wraps.length) return;

    var targets = wraps.map(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return null;

      var depth = Number(wrap.getAttribute('data-parallax')) || 30;

      // ✅ SPは弱めに（酔い対策）
      if (win.innerWidth < 900) depth = depth * 0.45;

      img.style.willChange = 'transform';
      return { wrap: wrap, img: img, depth: depth };
    }).filter(Boolean);

    if (!targets.length) return;

    var state = targets.map(function () {
      return { x:0, y:0, r:0, s:1, tx:0, ty:0, tr:0, ts:1 };
    });

    function compute() {
      var vh = win.innerHeight || 1;

      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        var rect = t.wrap.getBoundingClientRect();

        var start = vh;
        var end = -rect.height;
        var p = (start - rect.top) / (start - end);
        p = clamp(p, 0, 1);

        var u = (p * 2) - 1;
        var d = t.depth;

        state[i].ty = -u * d;
        state[i].tx =  u * (d * 0.18);
        state[i].tr =  u * (d * 0.012);
        state[i].ts = 1 + Math.abs(u) * 0.006;
      }
    }

    function draw() {
      for (var i = 0; i < targets.length; i++) {
        var t = targets[i];
        var s = state[i];

        s.y = lerp(s.y, s.ty, 0.09);
        s.x = lerp(s.x, s.tx, 0.09);
        s.r = lerp(s.r, s.tr, 0.09);
        s.s = lerp(s.s, s.ts, 0.09);

        t.img.style.transform =
          'translate3d(' + s.x.toFixed(2) + 'px,' + s.y.toFixed(2) + 'px,0) ' +
          'rotate(' + s.r.toFixed(3) + 'deg) ' +
          'scale(' + s.s.toFixed(3) + ')';
      }
      requestAnimationFrame(draw);
    }

    var onTick = rafThrottle(compute);
    win.addEventListener('scroll', onTick, { passive: true });
    win.addEventListener('resize', onTick);

    compute();
    requestAnimationFrame(draw);
  }

  // ==========================
  // Boot
  // ==========================
  ready(function () {
    try { initOverlayAndFade(); } catch (e1) { console.warn('[about-core v2] overlay/fade', e1); }
    try { initTabs(); }          catch (e2) { console.warn('[about-core v2] tabs', e2); }
    try { initApproachInview(); }catch (e3) { console.warn('[about-core v2] approach', e3); }
    try { initMarquee(); }       catch (e4) { console.warn('[about-core v2] marquee', e4); }
    try { initFloat(); }         catch (e5) { console.warn('[about-core v2] float', e5); }
  });

})();